"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins, Ref } from "vue-property-decorator";
import Layout from "../components/layout/Layout.vue";
import VirtualShopContent, {
  Controller
} from "@/components/virtual-shop/VirtualShopContent.vue";
import { AccountSessionMixins } from "@/service/account-session";
import MainView from "@/components/layout/MainView.vue";
import MainGroups from "@/components/virtual-shop/elements/MainGroups.vue";
import VirtualShopTableBody from "@/components/virtual-shop/body/table/VirtualShopTableBody.vue";
import HeaderToolbar from "@/components/virtual-element/elements/HeaderToolBar.vue";
import HeaderSearch from "@/components/virtual-element/elements/HeaderSearch.vue";
import AdvancedSearchForm from "@/components/virtual-shop/elements/search/AdvancedSearchFormDrawer.vue";
import BatchOperate from "@/components/virtual-element/elements/BatchOperate.vue";
import BatchOperateRenew from "@/components/virtual-shop/batch-operate/BatchOperateRenew.vue";
import VirtualdesktopForm from "@/views/virtualdesktopItems/components/dialog-forms/VirtualdesktopForm.vue";
import MultiImportMembers from "@/views/shopItems/components/MultiImportMembers.vue";
import {
  SearchFormController,
  UiFormAnnotations
} from "@/components/form/UiForm.vue";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import ShopBindVd from "@/views/bindItems/ShopBindVd.vue";
import ShopBindAdmin from "@/views/bindItems/ShopBindAdmin.vue";
import AddVisitDialog from "@/views/shopItems/components/AddVisitDialog.vue";
import ShopGroupDialog from "@/views/groupItems/ShopGroupDialog.vue";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import { Changeteam } from "@/service/Teamchange/changeteam";
import { SessionStore } from "@/service/session";
import { DeviceFormatter } from "@/service/DeviceInfo/deviceFormatter";
import AuthPinLogin from "@/views/auth/components/AuthPinLogin.vue";
import AccountDevice from "@/views/auth/components/AccountDevice.vue";
import ChangeCodeDialog from "./shopItems/components/ChangeCodeDialog.vue";
import VirtualShopEmpty from "@/components/virtual-shop/body/items/VirtualShopEmpty.vue";
import VirtualShopUpgradeTip from "@/components/virtual-shop/body/items/VirtualShopUpgradeTip.vue";
import ShopVideoOpenTipDialog from "@/views/virtualdesktopItems/components/dialog-forms/ShopVideoOpenTipDialog.vue";
import timeformatter from "@/framework/timeformatter";
import ForceExitDialog from "./shopItems/components/ForceExitDialog.vue";
import ImportCookiesDialog from "./virtualdesktopItems/components/dialog-forms/ImportCookiesDialog.vue";
import EditRemarkDialog from "./virtualdesktopItems/components/dialog-forms/EditRemarkDialog.vue";
import EditCookieStatusDialog from "./virtualdesktopItems/components/dialog-forms/EditCookieStatusDialog.vue";
import EditCookieRemarkDialog from "./virtualdesktopItems/components/dialog-forms/EditCookieRemarkDialog.vue";
import CookieManageDialog from "./virtualdesktopItems/components/dialog-forms/CookieManageDialog.vue";
import CookieManageLogDialog from "./virtualdesktopItems/components/dialog-forms/CookieManageLogDialog.vue";
import PrivacyModeDialog from "./virtualdesktopItems/components/dialog-forms/PrivacyModeDialog.vue";
export class VirtualShopSearch extends SearchFormController {
  constructor() {
    super(...arguments);
    this.keyword = null;
    // name: Optional<string> = null;
    this.name = null;
    this.ip = null;
    this.group = null;
    // ebusiness_ids: Optional<string[]> = [];
    this.ebusinessIds = [];
    this.platforms = [];
    // user_ids: Optional<string[]> = [];
    this.userIds = [];
    // userIds: Optional<string[]> = [];
    this.expiryDate = [];
    // login_start_time: Optional<string> = null;
    this.loginStartTime = null;
    // login_end_time: Optional<string> = null;
    this.loginEndTime = null;
    this.data_status = null;
    // bind_vd: any = null;
    this.bindVd = null;
    // shop_lock: any = null;
    this.lock = null;
  }
  clear() {
    this.keyword = null;
    this.ip = null;
    this.group = null;
    this.expiryDate = [];
    this.data_status = null;
    this.name = null;
    this.ebusinessIds = [];
    this.platforms = [];
    this.userIds = [];
    this.loginStartTime = null;
    this.loginEndTime = null;
    this.bindVd = null;
    this.lock = null;
  }
}
__decorateClass([
  UiFormAnnotations.Query((property, value) => {
    if (value) {
      return ["name", `%${value}%`];
    }
    return ["name", null];
  })
], VirtualShopSearch.prototype, "keyword", 2);
__decorateClass([
  UiFormAnnotations.Query((property, value) => {
    if (value) {
      return ["group", value.id];
    }
    return ["group", null];
  })
], VirtualShopSearch.prototype, "group", 2);
__decorateClass([
  UiFormAnnotations.Query((property, value) => {
    return [property, _.map(value, "id")];
  })
], VirtualShopSearch.prototype, "ebusinessIds", 2);
__decorateClass([
  UiFormAnnotations.Query((property, value) => {
    return [property, _.map(value, "guid")];
  })
], VirtualShopSearch.prototype, "userIds", 2);
__decorateClass([
  UiFormAnnotations.Query((property, value) => {
    if (value) {
      return ["vdStatus", value.value];
    }
    return ["vdStatus", null];
  })
], VirtualShopSearch.prototype, "data_status", 2);
let VirtualShopHome = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    //店铺列表高级搜索
    this.contentController = new Controller();
    this.batchOperates = new Map(
      function* () {
        yield [
          "batch-edit-group",
          require("@/components/virtual-shop/batch-operate/BatchOperateEditGroup.vue").default
        ];
        yield [
          "batch-edit-shop",
          require("@/components/virtual-shop/batch-operate/BatchOperateRenew.vue").default
        ];
        yield [
          "batch-bind-vd",
          require("@/components/virtual-shop/batch-operate/BatchOperateBindVD.vue").default
        ];
        yield [
          "batch-bind-admin",
          require("@/components/virtual-shop/batch-operate/BatchOperateBindAdmin.vue").default
        ];
        yield [
          "batch-unbind-admin",
          require("@/components/virtual-shop/batch-operate/BatchOperateUnbindAdmin.vue").default
        ];
        yield [
          "batch-delete-shop",
          require("@/components/virtual-shop/batch-operate/BatchOperateDeletaShop.vue").default
        ];
      }()
    );
    //是否删除cookie
    this.del_cookie = false;
    //视图监听器
    this.view_listener = null;
    //全部团队的ID
    this.all_teams = SessionStore.get("all_team_id");
    //当前团队的ID
    this.now_team = SessionStore.get("now_team_id");
    //高级搜索参数
    this.searchQuery = new VirtualShopSearch();
    //当前分组的店铺数量
    this.groupNum = null;
  }
  mounted() {
    return __async(this, null, function* () {
      if (localStorage.getItem("shop.page") !== null) {
        let page = Number(localStorage.getItem("shop.page"));
        this.contentController.query.current = page;
      }
      if (localStorage.getItem("shop.size") !== null) {
        let size = Number(localStorage.getItem("shop.size"));
        this.contentController.query.size = size;
      }
    });
  }
  //强制下线弹窗
  openForceDialog(item) {
    return __async(this, null, function* () {
      yield this._forceExitDialog.open(item);
    });
  }
  //切换分组
  groupChange(index, indexPath) {
    var _a;
    this.groupNum = ((_a = this._main_group._controller.groups.find((item) => {
      return item.id === index;
    })) == null ? void 0 : _a.quantity) || 0;
    this.searchQuery.clear();
    this.contentController.query.filter = {
      // groupId: index,
      group: index
    };
    this._main_group.checkGroupMove();
    for (const [_name, _value] of this.searchQuery.query().entries()) {
      if (_value === null || _value === "" || _value === "null") {
        continue;
      }
      _.set(this.contentController.query.filter, _name, _value);
    }
    localStorage.setItem("shop.page", "1");
    localStorage.setItem("shop.size", "10");
    localStorage.setItem("shop.group", index);
    if (index === "shopgroup_system_lately") {
      this.contentController.query.sort = "createdTime,desc";
    } else {
      this.contentController.query.sort = "createdTime,desc";
    }
    if (this._shopTableBody && this._shopTableBody._tableBody) {
      this._shopTableBody._tableBody.clearSort();
    }
    this.contentController.query.current = 1;
    this.contentController.query.size = 10;
    this.contentController.search();
  }
  //跳转至支付页面
  jumptopayment() {
    return __async(this, null, function* () {
      this.$router.push({ path: "/payment", query: { style: "create" } });
    });
  }
  //清除选项
  clearBatch() {
    this._shopTableBody.clearSelection();
  }
  //搜索店铺列表
  search(search) {
    const _group = _.get(this.contentController.query.filter, "group");
    this.contentController.query.filter = {};
    if (search instanceof SearchFormController) {
      for (const [_name, _value] of search.query().entries()) {
        _.set(this.contentController.query.filter, _name, _value);
      }
      this.contentController.query.current = 1;
    }
    _.set(this.contentController.query.filter, "group", _group);
    this.contentController.search();
  }
  //创建店铺
  createShop() {
    let that = this;
    this._shopFormDialog.open();
  }
  //切换到续费分组
  toRenewGroup() {
    return __async(this, null, function* () {
      localStorage.removeItem("page_mode");
      this.$router.push({ path: "/main", query: { jumpto: "renew" } });
    });
  }
  //导入店铺
  importShop() {
    this._multi_import_members.open("create_shop");
  }
  //跳转店铺详情
  shopDetail(data) {
    return __async(this, null, function* () {
      this.$router.push({ name: "ShopDetail", query: { id: data.id } });
    });
  }
  //编辑店铺
  editShop(data) {
    return __async(this, null, function* () {
      try {
        if (data.marks.is("IS_ADMIN")) {
          this._shopFormDialog.open(data.id, data.vd_guid, true);
        } else {
          this._shopFormDialog.open(data.id, data.vd_guid, false);
        }
      } catch (e) {
        console.dir(e);
      }
    });
  }
  //绑定IP与店铺
  bindIP(data) {
    return __async(this, null, function* () {
      this._shopBindVd.open([data.modelResource], data.vd_guid);
    });
  }
  //绑定IP与店铺（回收站）
  bindIPDelete(data) {
    return __async(this, null, function* () {
      this._shopBindVd.open([data.modelResource], data.vd_guid, "delete");
    });
  }
  //打开Cookie备份管理
  cookieEditor(data) {
    this._cookie_manage_dialog.open(data);
  }
  openLogDialog(data) {
    this._cookie_manage_log_dialog.open(data);
  }
  openEditRemark(row) {
    this._edit_cookie_remark_dialog.open(row);
  }
  openEditStatus(row) {
    this._edit_cookie_status_dialog.open(row);
  }
  refreshCookie() {
    return __async(this, null, function* () {
      try {
        yield this._cookie_manage_dialog.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //批量导出店铺
  exportShops() {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.confirm(
          this.$t("order.export_info_tip"),
          this.$t("order.export_info_title"),
          {
            cancelButtonText: this.$t("order.export_cancel"),
            confirmButtonText: this.$t("order.export_confirm")
          }
        );
        const response = yield API.get(
          `api://base.auth.pro/v1/shops/current/export/all`,
          {
            params: {
              sort: this.contentController.query.sort,
              size: this.contentController.query.size,
              page: this.contentController.query.current,
              search: ((obj) => {
                let str = "";
                for (const prop in obj) {
                  if (Array.isArray(this.contentController.query.filter[prop])) {
                    if (!this.contentController.query.filter[prop].length) {
                      continue;
                    }
                    if (prop === "expiryDate") {
                      continue;
                    }
                    let substr = `${prop}=in=(`;
                    this.contentController.query.filter[prop] = this.contentController.query.filter[prop].map(
                      (item) => {
                        return `"${item}"`;
                      }
                    );
                    substr += this.contentController.query.filter[prop].join(",");
                    str += `${substr});`;
                  } else {
                    if (this.contentController.query.filter[prop] === null) {
                      continue;
                    }
                    if (prop === "name") {
                      str += `${prop}=like="${obj[prop]}";`;
                    } else if (prop === "loginStartTime") {
                      str += `lastLoginTime=between=(${Date.parse(obj["loginStartTime"]) / 1e3},${Date.parse(obj["loginEndTime"]) / 1e3});`;
                    } else if (prop === "loginEndTime") {
                      continue;
                    } else if (prop === "bindVd") {
                      if (obj[prop] === true) {
                        str += `status==BIND_VD;`;
                      } else if (obj[prop] === false) {
                        str += `status==NOT_BIND_VD;`;
                      } else {
                        continue;
                      }
                    } else {
                      str += `${prop}=="${obj[prop]}";`;
                    }
                  }
                }
                return str;
              })(this.contentController.query.filter)
            }
          }
        );
        yield new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve(true);
          }, 3e3);
        });
        fetch(response.data.url).then((response2) => response2.blob()).then((blob) => {
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = response.data.title;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //编辑备注
  editRemark(item) {
    return __async(this, null, function* () {
      this._edit_remark_dialog.open(item);
    });
  }
  //为选中店铺分配管理员
  chooseAdmin(item) {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth.pro/v1/shop/${item.id}/auth-users`);
        let _list = _.map(response.data.datas, (data) => {
          return {
            // id: data.guid,
            id: data.id,
            label: `${data.name} (${data.number.toString().substring(
              data.number.toString().length - 4,
              data.number.toString().length
            )})`
          };
        });
        this._shopBindAdmin.open("single", [item.modelResource], _list);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //删除缓存
  deleteCache(item) {
    return __async(this, null, function* () {
      let response = yield API.get(`api://base.local/v2/dynamic-browsers`);
      let arr = response.data.data;
      let exist = false;
      for (let browserItem of arr) {
        if (item.shopOldId === browserItem.id) {
          exist = true;
          break;
        }
      }
      if (exist) {
        yield UiConfirm.warnconfirm(
          this.$t("main.has_opening_browser", {
            name
          }),
          this.$t("headertoolbar.hint"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            cancelButtonText: this.$t("headertoolbar.cancel"),
            iconClass: "el-icon-warning"
          }
        );
        yield API.delete(`api://base.local/v2/dynamic-browsers/${item.shopOldId}`);
      }
      const h = this.$createElement;
      let self = this;
      this.$confirm("", this.$t("main.hint"), {
        message: h("div", void 0, [
          h(
            "div",
            {
              class: "text-content",
              style: "overflow: hidden;text-overflow: ellipsis;"
            },
            `${this.$t("main.do_you_want_to_delete", { name: item.name })}`
          ),
          h(
            "el-checkbox",
            {
              class: {
                "ui-checkbox": true
              },
              key: Math.random(),
              domProps: {
                checked: self.del_cookie
              },
              on: {
                input: function(event) {
                  self.del_cookie = event;
                }
              }
            },
            this.$t("main.at_the_same_time_delete_the_store_binding")
          )
        ]),
        confirmButtonText: this.$t("main.delete"),
        roundButton: true,
        cancelButtonText: this.$t("main.cancel"),
        type: "warning"
      }).then(() => __async(this, null, function* () {
        var _a, _b;
        try {
          if (this.del_cookie) {
            yield API.delete(`api://base.auth/api/v8/shop-cookies/${item.shopOldId}`);
            this.del_cookie = false;
          }
          yield API.post(`api://base.local/websockets/main`, {
            model: "delete.shop.cache",
            vd_id: (_a = item.vd) == null ? void 0 : _a.oldId,
            shop_id: item.shopOldId,
            account: (_b = this.$session) == null ? void 0 : _b.account
          });
          this.$message.success(this.$t("main.delete_successful"));
          this.refresh();
        } catch (error) {
          this.del_cookie = false;
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      })).catch((error) => {
        console.log(error);
        this.del_cookie = false;
        return;
      });
    });
  }
  //添加额外访问
  additionalAccess(item) {
    this._addVisitDialog.open(item.modelResource);
  }
  //店铺置顶
  stickToTop(data) {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.auth.pro/v1/shops/${data.id}/tops`);
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //取消店铺置顶
  unstickToTop(data) {
    return __async(this, null, function* () {
      try {
        yield API.delete(`api://base.auth.pro/v1/shops/${data.id}/tops`);
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //编辑分组
  editGroup(item) {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.auth.pro/v1/shops/${item.id}/groups`
        );
        let selectDatas = response.data.groupIds;
        this._shopGroupDialog.open([item.id], selectDatas);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //修改店铺code
  changeCode(item) {
    try {
      this._change_coode_dialog.open(item);
    } catch (error) {
    }
  }
  //添加店铺视频认证
  addVideo(item) {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v8/shops/${item.shopOldId}/video-auth`
        );
        if (response.data.open) {
          let startTime = timeformatter.dateformatter(timeformatter.check(response.data.startTime));
          let endTime = timeformatter.format_open_date(timeformatter.check(response.data.endTime));
          yield UiConfirm.confirm(
            this.$t("main.open_shop_video_again_tips_content", {
              startTime,
              endTime
            }),
            this.$t("main.open_shop_video_again_tips_title"),
            {
              showConfirmButton: true,
              confirmButtonText: this.$t(
                "main.open_shop_video_again_confirm_btn"
              ),
              roundButton: true
            }
          );
          return;
        }
        yield this._shopVideoOpenTipDialog.open(item);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //开启导入cookie的弹窗
  importCookies(item) {
    this._import_cookies_dialog.open(item);
  }
  //关闭店铺视频认证
  closeVideo(item) {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v8/shops/${item.shopOldId}/video-auth`
        );
        if (response.data.open) {
          let startTime = timeformatter.dateformatter(timeformatter.check(response.data.startTime));
          let endTime = timeformatter.format_open_date(timeformatter.check(response.data.endTime));
          yield UiConfirm.confirm(
            this.$t("main.close_shop_video_tips_content", {
              startTime,
              endTime
            }),
            this.$t("main.close_shop_video_tips_title"),
            {
              showConfirmButton: true,
              confirmButtonText: this.$t(
                "main.close_shop_video_tips_confirm_btn"
              ),
              roundButton: true,
              showCancelButton: true,
              cancelButtonText: this.$t(
                "main.close_shop_video_tips_cancel_btn"
              )
            }
          );
          yield API.delete(`api://base.auth/api/v8/shops/${item.shopOldId}/video-auth`);
          this.$message.success(
            this.$t("main.close_shop_video_tips_confirm_message")
          );
          yield this.refresh();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 隐私模式启动
  privacyMode(item) {
    return __async(this, null, function* () {
      this._privacy_mode_dialog.open(item);
    });
  }
  // 隐藏回收站店铺
  realDeleteShop(item) {
    return __async(this, null, function* () {
      let _arr = [];
      _arr.push(item.modelResource);
      let ids = [];
      for (const item2 of _arr) {
        ids.push(item2.id);
      }
      this.$confirm(
        `${this.$t("main.this_operation_will_permanently_delete_the_store", {
          name: item.name
        })}<br/>
      ${this.$t("main.after_delete_message")}
      `,
        this.$t("main.hint"),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t("main.delete"),
          cancelButtonText: this.$t("main.cancel"),
          roundButton: true,
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        try {
          yield API.put(`api://base.auth.pro/v1/shops-recycle-hide`, {
            ids,
            hide: true
          });
          this.$message.success(this.$t("main.delete_successful"));
          this.refresh();
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            console.log(error);
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      })).catch((error) => {
        console.log(error);
        return;
      });
    });
  }
  //删除店铺
  deleteShop(item) {
    return __async(this, null, function* () {
      let _arr = [];
      _arr.push(item.modelResource);
      let ids = [];
      for (const item2 of _arr) {
        ids.push(item2.id);
      }
      this.$confirm(
        `${this.$t("main.this_operation_will_permanently_delete_the_store", {
          name: item.name
        })}<br/>
      ${this.$t("main.after_delete_message")}
      `,
        this.$t("main.hint"),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t("main.delete"),
          cancelButtonText: this.$t("main.cancel"),
          roundButton: true,
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        try {
          yield API.delete(`api://base.auth.pro/v1/shops`, {
            data: {
              shopIds: ids
            }
          });
          this.$message.success(this.$t("main.delete_successful"));
          this.refresh();
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            console.log(error);
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      })).catch((error) => {
        console.log(error);
        return;
      });
    });
  }
  //刷新店铺列表
  showAdvancedSearch() {
    const _advancedSearchForm = AdvancedSearchForm.create(this.searchQuery);
    _advancedSearchForm.$on("search", this.search);
    _advancedSearchForm.show();
  }
  //批量编辑店铺
  batchEditShop() {
    this._multi_import_members.open("edit_shop");
  }
  //批量编辑分组
  batchEditGroup() {
    let arr = _.map(this.contentController.selected, "id");
    this._shopGroupDialog.open(arr);
  }
  //批量绑定VD
  editbindVD() {
    let arr = _.map(
      this.contentController.selected,
      "modelResource"
    );
    this._shopBindVd.open(arr);
  }
  //批量绑定管理员
  editbindAdmin() {
    let arr = _.map(
      this.contentController.selected,
      "modelResource"
    );
    this._shopBindAdmin.open("multi", arr);
  }
  //批量解绑管理员
  editUnbindAdmin() {
    return __async(this, null, function* () {
      try {
        let arr = _.map(this.contentController.selected, "id");
        yield API.post(`api://base.auth.pro/v1/shops-users`, {
          "model": "shops.auth.users",
          "mode": "COVER",
          "shopIds": arr,
          "userIds": []
        });
        yield this.refresh();
        this.$message.success(this.$t("main.unbind_admin_success"));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // addShopLock(){
  // }
  // 批量隐藏回收站店铺
  batchrealDeleteShop() {
    return __async(this, null, function* () {
      let ids = [];
      for (const item of this.contentController.selected) {
        ids.push(item.id);
      }
      this.$confirm(
        `${this.$t("main.this_operation_will_permanently_delete_the_stores")}<br/>
        ${this.$t("main.after_delete_message")}
      `,
        this.$t("main.hint"),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t("main.delete"),
          cancelButtonText: this.$t("main.cancel"),
          roundButton: true,
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        try {
          yield API.put(`api://base.auth.pro/v1/shops-recycle-hide`, {
            ids,
            hide: true
          });
          this.$message.success(this.$t("main.delete_successful"));
          this.refresh();
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      })).catch((error) => {
        return;
      });
    });
  }
  //批量删除店铺
  batchdeleteShop() {
    return __async(this, null, function* () {
      let ids = [];
      for (const item of this.contentController.selected) {
        ids.push(item.id);
      }
      this.$confirm(
        `${this.$t("main.this_operation_will_permanently_delete_the_stores")}<br/>
    ${this.$t("main.after_delete_message")}
    `,
        this.$t("main.hint"),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t("main.delete"),
          cancelButtonText: this.$t("main.cancel"),
          roundButton: true,
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        try {
          yield API.delete(`api://base.auth.pro/v1/shops`, {
            data: {
              shopIds: ids
            }
          });
          this.$message.success(this.$t("main.delete_successful"));
          this.refresh();
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      })).catch((error) => {
        return;
      });
    });
  }
  //批量导出店铺
  groupManagerDialog() {
    return __async(this, null, function* () {
      this._shopGroupDialog.open();
    });
  }
  //批量导出店铺
  refresh() {
    return __async(this, null, function* () {
      yield this._main_group.refresh();
      yield this.contentController.search();
    });
  }
  //切换团队
  changeTeam() {
    return __async(this, null, function* () {
      let team_id = "";
      try {
        let response = yield API.get(`api://base.auth/api/v8/users/owned_org`);
        team_id = response.data.org_guid;
      } catch (error) {
      }
      let item = _.find(this.all_teams, { team_id });
      let name2 = this.$t("headertoolbar.target_team");
      if (item !== void 0) {
        name2 = item.team_name;
      }
      try {
        let _browsers = yield API.get(`api://base.local/v2/browsers`);
        if (_browsers.data.data.length > 0) {
          yield UiConfirm.warnconfirm(
            this.$t("headertoolbar.has_opening_browser", {
              name: name2
            }),
            this.$t("headertoolbar.hint"),
            {
              confirmButtonText: this.$t("headertoolbar.confirm"),
              cancelButtonText: this.$t("headertoolbar.cancel"),
              iconClass: "el-icon-warning"
            }
          );
          yield API.delete(`api://base.local/v2/browsers`);
          yield API.delete(`api://base.local/v2/dynamic-browsers`);
          yield API.delete(`api://base.local/processes`);
        }
      } catch (error) {
      }
      yield UiConfirm.confirm(
        `${this.$t("headertoolbar.whether_to_switch", { name: name2 })}`,
        this.$t("headertoolbar.switch_team"),
        {
          confirmButtonText: this.$t("headertoolbar.confirm"),
          cancelButtonText: this.$t("headertoolbar.cancel")
        }
      );
      let loading = this.$loading({
        lock: true,
        fullscreen: true,
        text: this.$t(
          "headertoolbar.switching_teams_please_wait_a_moment"
        ),
        customClass: "hard-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
      console.log("=========================================================");
      let _res = yield Changeteam.change(team_id, "old");
      console.log(_res);
      if (_res.type === "pin") {
        loading.close();
        yield this._auth_pin.open(_res.result, "team");
        return;
      }
      if (_res.type === "device") {
        loading.close();
        yield this._account_device.open(
          _res.result,
          "team"
        );
        return;
      }
      if (_res.type === "error") {
        loading.close();
        yield UiConfirm.confirm(
          `${_res.result}`,
          this.$t("headertoolbar.hint"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            showCancelButton: false
          }
        );
      }
      if (_res.type === "success") {
        let _session = yield API.get(`api://base.auth/api/v9/account/session`);
        const session = _session.data;
        yield API.put(`api://base.local/storages/session/session`, {
          session
        });
        localStorage.removeItem("gift_show");
        new Promise((resolve, reject) => {
          setTimeout(() => {
            loading.close();
            resolve(true);
          }, 1500);
        });
        yield this.sendLog();
        yield API.post(`api://base.local/websockets/messageservice`, {
          model: "pageEvent.changeTeam.success",
          value: {
            message: "changeteam.success"
          }
        });
        yield API.post(`api://base.local/websockets/view`, {
          model: "pageEvent.changeTeam.success",
          value: {
            message: "changeteam.success"
          }
        });
        yield API.post(`api://base.local/websockets/main`, {
          model: "change.team.success",
          value: {
            message: "changeteam.success"
          }
        });
        location.reload();
      }
    });
  }
  //获取团队列表
  getTeamList() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v1/team/teamlist`);
        let all_teams_id = SessionStore.get("all_team_id");
        let now_teams_id = SessionStore.get("now_team_id");
        let item = _.find(response.data.datas, { team_choose: true });
        let all_teams = response.data.datas;
        let now_teams = item.team_id;
        if (all_teams_id !== all_teams || now_teams_id !== now_teams) {
          SessionStore.set("all_team_id", all_teams);
          SessionStore.set("now_team_id", now_teams);
          this.all_teams = all_teams;
          this.now_team = now_teams;
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  //发送日志
  sendLog() {
    return __async(this, null, function* () {
      try {
        let device = yield DeviceFormatter.getInfo();
        let version = yield API.get(`api://base.local/update/version`);
        let _version = version.data.version;
        let _session = yield API.get(
          `api://base.local/storages/session/session`
        );
        yield API.post(`api://base.auth/api/v3/client/logs`, {
          logs: [
            {
              name: "client.login",
              message: "login.success",
              datas: {
                time: {
                  time: new Date().getTime(),
                  date: new Date()
                },
                session: _session.data.value.session,
                version: _version,
                patch: _version,
                computer: {
                  graphics: device.device_info.detail.graphics,
                  os_arch: device.device_info.os_arch,
                  cpu: device.device_info.detail.cpu,
                  os: device.device_info.detail.osInfo,
                  memory: device.device_info.detail.mem,
                  network: device.device_info.detail.networkInterfaces,
                  time: {
                    date: new Date()
                  }
                }
              }
            }
          ]
        });
      } catch (error) {
        console.dir(error);
      }
    });
  }
};
__decorateClass([
  Ref("shop-video-open-tip-dialog")
], VirtualShopHome.prototype, "_shopVideoOpenTipDialog", 2);
__decorateClass([
  Ref("shop-form-dialog")
], VirtualShopHome.prototype, "_shopFormDialog", 2);
__decorateClass([
  Ref("main-group")
], VirtualShopHome.prototype, "_main_group", 2);
__decorateClass([
  Ref("multi-import-members")
], VirtualShopHome.prototype, "_multi_import_members", 2);
__decorateClass([
  Ref("shop-bind-vd")
], VirtualShopHome.prototype, "_shopBindVd", 2);
__decorateClass([
  Ref("shop-bind-admin")
], VirtualShopHome.prototype, "_shopBindAdmin", 2);
__decorateClass([
  Ref("add-visit-dialog")
], VirtualShopHome.prototype, "_addVisitDialog", 2);
__decorateClass([
  Ref("shop-group-dialog")
], VirtualShopHome.prototype, "_shopGroupDialog", 2);
__decorateClass([
  Ref("shop_table_body")
], VirtualShopHome.prototype, "_shopTableBody", 2);
__decorateClass([
  Ref("force_exit_dialog")
], VirtualShopHome.prototype, "_forceExitDialog", 2);
__decorateClass([
  Ref("auth-pin")
], VirtualShopHome.prototype, "_auth_pin", 2);
__decorateClass([
  Ref("account-device")
], VirtualShopHome.prototype, "_account_device", 2);
__decorateClass([
  Ref("change-code-dialog")
], VirtualShopHome.prototype, "_change_coode_dialog", 2);
__decorateClass([
  Ref("import_cookies_dialog")
], VirtualShopHome.prototype, "_import_cookies_dialog", 2);
__decorateClass([
  Ref("edit_remark_dialog")
], VirtualShopHome.prototype, "_edit_remark_dialog", 2);
__decorateClass([
  Ref("cookie_manage_dialog")
], VirtualShopHome.prototype, "_cookie_manage_dialog", 2);
__decorateClass([
  Ref("cookie_manage_log_dialog")
], VirtualShopHome.prototype, "_cookie_manage_log_dialog", 2);
__decorateClass([
  Ref("edit_cookie_status_dialog")
], VirtualShopHome.prototype, "_edit_cookie_status_dialog", 2);
__decorateClass([
  Ref("edit_cookie_remark_dialog")
], VirtualShopHome.prototype, "_edit_cookie_remark_dialog", 2);
__decorateClass([
  Ref("privacy_mode_dialog")
], VirtualShopHome.prototype, "_privacy_mode_dialog", 2);
VirtualShopHome = __decorateClass([
  Component({
    components: {
      VirtualShopContent,
      VirtualShopTableBody,
      VirtualShopUpgradeTip,
      Layout,
      MainGroups,
      MainView,
      HeaderSearch,
      HeaderToolbar,
      BatchOperate,
      BatchOperateRenew,
      VirtualdesktopForm,
      MultiImportMembers,
      ShopBindVd,
      ShopBindAdmin,
      AddVisitDialog,
      ShopGroupDialog,
      AuthPinLogin,
      AccountDevice,
      ChangeCodeDialog,
      VirtualShopEmpty,
      ShopVideoOpenTipDialog,
      ForceExitDialog,
      ImportCookiesDialog,
      EditRemarkDialog,
      CookieManageDialog,
      CookieManageLogDialog,
      EditCookieStatusDialog,
      EditCookieRemarkDialog,
      PrivacyModeDialog
    }
  })
], VirtualShopHome);
export {
  VirtualShopHome as default
};
